import {
    GET_SUBSCRIPTIONS,
    GET_SUBSCRIPTIONS_SUCCESS,
    GET_SUBSCRIPTIONS_FAILURE,
    CREATE_SUBSCRIPTION_SESSION,
} from "../constants";

const initialState = {
    loader: false,
    data: undefined,
}

export default function SubscriptionsReducer(state = initialState, action) {

    switch (action.type) {

        case GET_SUBSCRIPTIONS:
            state = {
                ...state,
                loader: true
            }
            break;

        case GET_SUBSCRIPTIONS_SUCCESS:
            state = {
                ...state,
                loader: false,
                data: action.payload
            }
            break;

        case GET_SUBSCRIPTIONS_FAILURE:
            state = {
                ...state,
                loader: false
            }
            break;

        case CREATE_SUBSCRIPTION_SESSION:
            break

        default:
            state = { ...state }
            break
    }
    return state
}